var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "34 23 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8A8A8A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.912 39.016l-1.968-.967-1.5.808 1.641.802-8.99 4.844-8.886-4.838 1.735-.785-1.495-.815-2.063.95a.698.698 0 0 0-.021 1.24l10.393 5.66a.696.696 0 0 0 .667.001l10.502-5.66a.7.7 0 0 0-.015-1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.834 33.061l-1.499.81 1.75.888-8.99 4.844-8.886-4.838 1.867-.938-1.496-.815-2.194 1.103a.699.699 0 0 0-.021 1.24l10.393 5.66a.696.696 0 0 0 .667.001l10.502-5.66a.7.7 0 0 0-.015-1.24l-2.078-1.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.912 28.354L45.52 23.076a.703.703 0 0 0-.632-.002l-10.5 5.278a.702.702 0 0 0-.022 1.24l10.393 5.66a.71.71 0 0 0 .667.001l10.502-5.659a.7.7 0 0 0-.015-1.24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.12ff3e0c8c7b3b5ab78398ae01187638.svg";
export { ForwardRef as ReactComponent };